module.exports = __webpack_public_path__ + "325a73e0fe4240b7504b3819e3dc5ad8.MP3";